import { render, staticRenderFns } from "./SocialMediaForm.vue?vue&type=template&id=4db958e9&"
import script from "./SocialMediaForm.vue?vue&type=script&lang=js&"
export * from "./SocialMediaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports